export default {
  props: {
    isSunHotels: Boolean,
    showDelay: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {};
  },
  methods: {}
};
